import { render, staticRenderFns } from "./Refixings.vue?vue&type=template&id=210f9388"
import script from "./Refixings.vue?vue&type=script&lang=js"
export * from "./Refixings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports